import React from 'react'
import getLabels from '../../utils/getLabels'
import LoadingIcon from '../LoadingIcon'
import styles from './FlightMetaData.module.scss'

interface FlightMetaDataPropsInterface {
  route: string
  date: string
  flightNumber: string
  departureTime: string
  arrivalTime: string
  allotmentCount: number
  isFlightInformationAvailable: boolean
  showPassengersCount: boolean
  passengersCount?: number
}

export default (props: FlightMetaDataPropsInterface) => {
  const {
    route,
    date,
    flightNumber,
    departureTime,
    arrivalTime,
    passengersCount,
    allotmentCount,
    isFlightInformationAvailable,
    showPassengersCount,
  } = props

  const allotment = isFlightInformationAvailable ? allotmentCount : <LoadingIcon />
  const departure = isFlightInformationAvailable ? departureTime : <LoadingIcon />  
  const arrival = isFlightInformationAvailable ? arrivalTime : <LoadingIcon />

  return (
    <section>
      <h2 className={styles['route']}>{route}</h2>

      <dl className={styles['details']}>
        <span className={styles['detail']}>
          <dt>{getLabels('date')}</dt>
          <dd>{date}</dd>
        </span>

        <span className={styles['detail']}>
          <dt>{getLabels('flight_number')}</dt>
          <dd>{flightNumber}</dd>
        </span>

        <span className={styles['detail']}>
          <dt>{getLabels('departure')}</dt>
          <dd>{departure}</dd>
        </span>

        <span className={styles['detail']}>
          <dt>{getLabels('arrival')}</dt>
          <dd>{arrival}</dd>
        </span>

        {showPassengersCount && (
          <span className={styles['detail']}>
            <dt>{getLabels('passengers')}</dt>
            <dd>{passengersCount}</dd>
          </span>
        )}

        <span className={styles['detail']}>
          <dt>{getLabels('allotments_left')}</dt>
          <dd data-element="allotment-count">{allotment}</dd>
        </span>
      </dl>
    </section>
  )
}
